﻿import React from "react";
import {
  Typography,
  TextField,
  Grid,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  selectEditCatalogData,
  selectIsEditMode,
  setCatalogDataField,
} from "@/features/connections/manageCatalogDataSlice";
import {
  defaultCode,
  blankCode,
} from "@/features/connections/integrationSlice";
import { AddEditCatalogPopup } from "./CatalogPopup";

const AddCustomerPopup = ({ onClose, onValidate, onComplete }) => {
  const dispatch = useDispatch();
  const dataValues = useSelector(selectEditCatalogData);
  const isEdit = useSelector(selectIsEditMode);

  const validateForm = () => {
    if (onValidate) {
      const result = onValidate(dataValues);
      if (!result.isValid) return result;
    }
    if (dataValues.CustomerCode === defaultCode) {
      return {
        isValid: false,
        message: `Customer Code cannot be saved as ${defaultCode}`,
      };
    }
    if (dataValues.CustomerCode === blankCode) {
      return {
        isValid: false,
        message: `Customer Code cannot be saved as ${blankCode}`,
      };
    }
    if (dataValues.CustomerCode?.includes(",")) {
      return {
        isValid: false,
        message: `The Customer Code cannot include a ','`,
      };
    }
    return { isValid: true };
  };

  const handleClose = () => {
    onClose();
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    dispatch(setCatalogDataField({ name, value }));
  };

  return (
    <AddEditCatalogPopup
      onClose={handleClose}
      onValidate={validateForm}
      onComplete={onComplete}
    >
      <Grid item xs={4}>
        <Typography>Customer Code </Typography>
        <TextField
          disabled={isEdit}
          variant="outlined"
          name="CustomerCode"
          value={dataValues?.CustomerCode || ""}
          onChange={handleChange}
          sx={{
            width: 250,
            marginTop: 1,
            marginBottom: 2,
          }}
        />
      </Grid>
      <Grid item xs={4}>
        <Typography>
          Customer Name{" "}
        </Typography>
        <TextField
          variant="outlined"
          name="CustomerName"
          value={dataValues?.CustomerName || ""}
          onChange={handleChange}
          sx={{
            width: 250,
            marginTop: 1,
            marginBottom: 2,
          }}
        />
      </Grid>
      <Grid item xs={4}>
        <Typography>Bill To Name</Typography>
        <Typography>
          <TextField
            variant="outlined"
            name="BillToName"
            value={dataValues?.BillToName || ""}
            onChange={handleChange}
            sx={{
              width: 250,
              marginTop: 1,
              marginBottom: 2,
            }}
          />
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography>Bill To Address 1</Typography>
        <Typography>
          <TextField
            variant="outlined"
            name="BillToAddress1"
            value={dataValues?.BillToAddress1 || ""}
            onChange={handleChange}
            sx={{
              width: 250,
              marginTop: 1,
              marginBottom: 2,
            }}
          />
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography>Bill To Address 2</Typography>
        <Typography>
          <TextField
            variant="outlined"
            name="BillToAddress2"
            value={dataValues?.BillToAddress2 || ""}
            onChange={handleChange}
            sx={{
              width: 250,
              marginTop: 1,
              marginBottom: 2,
            }}
          />
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography>Bill To Address 3</Typography>
        <Typography>
          <TextField
            variant="outlined"
            name="BillToAddress3"
            value={dataValues?.BillToAddress3 || ""}
            onChange={handleChange}
            sx={{
              width: 250,
              marginTop: 1,
              marginBottom: 2,
            }}
          />
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography>Bill To Address 4</Typography>
        <Typography>
          <TextField
            variant="outlined"
            name="BillToAddress4"
            value={dataValues?.BillToAddress4 || ""}
            onChange={handleChange}
            sx={{
              width: 250,
              marginTop: 1,
              marginBottom: 2,
            }}
          />
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography>Bill To City</Typography>
        <Typography>
          <TextField
            variant="outlined"
            name="BillToCity"
            value={dataValues?.BillToCity || ""}
            onChange={handleChange}
            sx={{
              width: 250,
              marginTop: 1,
              marginBottom: 2,
            }}
          />
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography>Bill To State</Typography>
        <Typography>
          <TextField
            variant="outlined"
            name="BillToState"
            value={dataValues?.BillToState || ""}
            onChange={handleChange}
            sx={{
              width: 250,
              marginTop: 1,
              marginBottom: 2,
            }}
          />
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography>Bill To ZIP Code</Typography>
        <Typography>
          <TextField
            variant="outlined"
            name="BillToPostalCode"
            value={dataValues?.BillToPostalCode || ""}
            onChange={handleChange}
            sx={{
              width: 250,
              marginTop: 1,
              marginBottom: 2,
            }}
          />
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography>Bill To Country</Typography>
        <Typography>
          <TextField
            variant="outlined"
            name="BillToCountry"
            value={dataValues?.BillToCountry || ""}
            onChange={handleChange}
            sx={{
              width: 250,
              marginTop: 1,
              marginBottom: 2,
            }}
          />
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography>Bill To Phone</Typography>
        <Typography>
          <TextField
            variant="outlined"
            name="BillToPhone"
            value={dataValues?.BillToPhone || ""}
            onChange={handleChange}
            sx={{
              width: 250,
              marginTop: 1,
              marginBottom: 2,
            }}
          />
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography>Bill To Fax</Typography>
        <Typography>
          <TextField
            variant="outlined"
            name="BillToFax"
            value={dataValues?.BillToFax || ""}
            onChange={handleChange}
            sx={{
              width: 250,
              marginTop: 1,
              marginBottom: 2,
            }}
          />
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography>Bill To Email</Typography>
        <Typography>
          <TextField
            variant="outlined"
            name="BillToEmail"
            value={dataValues?.BillToEmail || ""}
            onChange={handleChange}
            sx={{
              width: 250,
              marginTop: 1,
              marginBottom: 2,
            }}
          />
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography>Bill To Website</Typography>
        <Typography>
          <TextField
            variant="outlined"
            name="BillToWebsite"
            value={dataValues?.BillToWebsite || ""}
            onChange={handleChange}
            sx={{
              width: 250,
              marginTop: 1,
              marginBottom: 2,
            }}
          />
        </Typography>
      </Grid>
    </AddEditCatalogPopup>
  );
};

export default AddCustomerPopup;
